var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloodErectile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#618FCA;}\n\t.st1{fill:#25384F;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:1.5678;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.4751;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 54.2,
    cy: 73.5,
    r: 4.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 90.5,
    cy: 42.7,
    r: 15.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 129,
    cy: 41.4,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 123.7,
    cy: 55.9,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 152.7,
    cy: 68.8,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 109.8,
    cy: 55.3,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 105.1,
    cy: 7.3,
    r: 6.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 69.7,
    cy: 47.1,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 79.8,
    cy: 60.3,
    r: 2.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65.6,
    cy: 61.6,
    r: 7.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 160.9,
    cy: 78.6,
    r: 3.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 113.6,
    cy: 44.2,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 140.4,
    cy: 57.8,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 113.9,
    cy: 24.1,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 94.6,
    cy: 19.3,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.9,210.9c41,0,74.2-32.9,74.2-73.5c0-40.6-33.2-73.5-74.2-73.5s-74.2,32.9-74.2,73.5 C30.7,178,63.9,210.9,104.9,210.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 85,
    cy: 125.6,
    r: 31.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "135.8,143.8 137.5,169.9 111.9,171.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 109.2,
    y1: 145.6,
    x2: 137.5,
    y2: 169.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.2,
    y1: 137.3,
    x2: 172.1,
    y2: 137.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134.5,
    y1: 86.4,
    x2: 138.9,
    y2: 79.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 134.4,
    y1: 188.4,
    x2: 139.6,
    y2: 194.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 156.4,
    y1: 108.2,
    x2: 163.3,
    y2: 104.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 156.6,
    y1: 166.3,
    x2: 163.8,
    y2: 169.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 141,
    y1: 91.2,
    x2: 146.9,
    y2: 84.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 146.7,
    y1: 96.3,
    x2: 153.2,
    y2: 90.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 151.5,
    y1: 101.9,
    x2: 158.9,
    y2: 96.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 159.4,
    y1: 115.3,
    x2: 167.9,
    y2: 112.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 161.7,
    y1: 122.2,
    x2: 170.5,
    y2: 120.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 163.2,
    y1: 129.5,
    x2: 172.2,
    y2: 128.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 163.2,
    y1: 144.7,
    x2: 172.2,
    y2: 145.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 161.8,
    y1: 152.1,
    x2: 170.6,
    y2: 154.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 159.4,
    y1: 159.3,
    x2: 167.8,
    y2: 162.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 152.1,
    y1: 172.2,
    x2: 159.3,
    y2: 177.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 147,
    y1: 178,
    x2: 153.7,
    y2: 184
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 141,
    y1: 183.2,
    x2: 147.5,
    y2: 189.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodErectile);
export default __webpack_public_path__ + "static/media/Blood_Erectile.aa21dc90bd75cce45c11bfc22832d011.svg";
export { ForwardRef as ReactComponent };